import { useState } from "react";
import { Users, ClipboardCheck, FileText, BookOpen } from "lucide-react";
import { sls, SIGTE_SESSION_KEY, sigteApiFetch } from "./sigteUtils";
import { SigteLogin } from "./SigteLogin";
import { SigteClientes } from "./SigteClientes";
import { SigteEdificios } from "./SigteEdificios";
import { SigteEquipos } from "./SigteEquipos";
import { SigteCatalogos } from "./SigteCatalogos";
import { SigteInspeccion } from "./SigteInspeccion";
import { SigteDictamenes } from "./SigteDictamenes";
import { SigteSidebarLayout } from "./SigteSidebarLayout";

// Iconos: match exacto con sigte-prototipo.jsx:2302-2312 (NAV.clientes,
// NAV.inspeccion, NAV.dictamen, NAV.catalogo).
var NAV_ITEMS = [
  { id: "clientes", label: "Clientes", icon: Users },
  { id: "inspeccion", label: "Inspección", icon: ClipboardCheck },
  { id: "dictamenes", label: "Dictámenes", icon: FileText },
  { id: "catalogos", label: "Catálogos", icon: BookOpen },
];

export default function SigteApp() {
  var [session,setSession]=useState(function(){return sls.get(SIGTE_SESSION_KEY,null);});
  var [tab,setTab]=useState("clientes");
  var [selectedCliente,setSelectedCliente]=useState(null);
  var [selectedEdificio,setSelectedEdificio]=useState(null);

  function login(u){ sls.set(SIGTE_SESSION_KEY,u); setSession(u); }
  function logout(){
    sigteApiFetch("/logout",{method:"POST"}).catch(function(){});
    sls.set(SIGTE_SESSION_KEY,null);
    setSession(null); setSelectedCliente(null); setSelectedEdificio(null);
  }
  function goClientes(){ setTab("clientes"); setSelectedCliente(null); setSelectedEdificio(null); }
  function goCatalogos(){ setTab("catalogos"); }
  function goInspeccion(){ setTab("inspeccion"); }
  function goDictamenes(){ setTab("dictamenes"); }
  function onNavigate(id){
    if(id==="clientes") goClientes();
    else if(id==="inspeccion") goInspeccion();
    else if(id==="dictamenes") goDictamenes();
    else if(id==="catalogos") goCatalogos();
  }

  if(!session) return <div className="sigte-scope"><SigteLogin onLogin={login}/></div>;

  var body;
  if(tab==="inspeccion"){
    body = <SigteInspeccion/>;
  } else if(tab==="dictamenes"){
    body = <SigteDictamenes/>;
  } else if(tab==="catalogos"){
    body = <SigteCatalogos/>;
  } else if(selectedEdificio){
    body = <SigteEquipos edificio={selectedEdificio} onBack={function(){setSelectedEdificio(null);}}/>;
  } else if(selectedCliente){
    body = <SigteEdificios cliente={selectedCliente} onBack={function(){setSelectedCliente(null);}} onOpenEdificio={setSelectedEdificio}/>;
  } else {
    body = <SigteClientes onOpenCliente={setSelectedCliente}/>;
  }

  return (
    <div className="sigte-scope">
      <SigteSidebarLayout navItems={NAV_ITEMS} activeId={tab} onNavigate={onNavigate}
        sessionTitle={session.nombre} sessionSubtitle={session.rol||""} onLogout={logout}>
        {body}
      </SigteSidebarLayout>
    </div>
  );
}
